function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _regeneratorValues(e) { if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
    if (t)
        return t.call(e);
    if ("function" == typeof e.next)
        return e;
    if (!isNaN(e.length))
        return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } };
} throw new TypeError(_typeof(e) + " is not iterable"); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, MenuItem, Tooltip, Select, FormControl, InputLabel, Checkbox, CircularProgress, Alert, Chip } from '@mui/material';
import { Add as AddIcon, 
// ListAltOutlined as EditIcon,
DeleteOutlined as DeleteIcon, InfoOutlined as InfoIcon, FilterListOutlined as FilterIcon } from '@mui/icons-material';
import AddUserModal from '../components/AddUserModal';
import { ConfirmationDialog } from '../components/ConfirmationDialog';
import UserDetailsModal from '../components/UserDetailsModal';
import { UserAPI } from '../apis/UserAPI';
import { isAuthorized } from '../utils/utilities';
var TeamAccess = function TeamAccess() {
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), users = _useState2[0], setUsers = _useState2[1];
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), roles = _useState4[0], setRoles = _useState4[1];
    var _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), applications = _useState6[0], setApplications = _useState6[1];
    var _useState7 = useState(''), _useState8 = _slicedToArray(_useState7, 2), accessFilter = _useState8[0], setAccessFilter = _useState8[1];
    var _useState9 = useState([]), _useState0 = _slicedToArray(_useState9, 2), selectedUsers = _useState0[0], setSelectedUsers = _useState0[1];
    var _useState1 = useState(false), _useState10 = _slicedToArray(_useState1, 2), loading = _useState10[0], setLoading = _useState10[1];
    var _useState11 = useState(true), _useState12 = _slicedToArray(_useState11, 2), dataLoading = _useState12[0], setDataLoading = _useState12[1];
    var _useState13 = useState(true), _useState14 = _slicedToArray(_useState13, 2), rolesLoading = _useState14[0], setRolesLoading = _useState14[1];
    var _useState15 = useState(null), _useState16 = _slicedToArray(_useState15, 2), error = _useState16[0], setError = _useState16[1];
    // Modal and dialog state
    var _useState17 = useState(false), _useState18 = _slicedToArray(_useState17, 2), userModalOpen = _useState18[0], setUserModalOpen = _useState18[1];
    var _useState19 = useState(null), _useState20 = _slicedToArray(_useState19, 2), selectedUser = _useState20[0], setSelectedUser = _useState20[1];
    var _useState21 = useState(false), _useState22 = _slicedToArray(_useState21, 2), confirmDialogOpen = _useState22[0], setConfirmDialogOpen = _useState22[1];
    var _useState23 = useState(null), _useState24 = _slicedToArray(_useState23, 2), userToDelete = _useState24[0], setUserToDelete = _useState24[1];
    var _useState25 = useState(false), _useState26 = _slicedToArray(_useState25, 2), userDetailsModalOpen = _useState26[0], setUserDetailsModalOpen = _useState26[1];
    var _useState27 = useState(null), _useState28 = _slicedToArray(_useState27, 2), selectedUserForDetails = _useState28[0], setSelectedUserForDetails = _useState28[1];
    // Load data on component mount
    useEffect(function () {
        loadInitialData();
    }, []);
    var loadInitialData = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var _yield$Promise$all, _yield$Promise$all2, usersWithRolesResponse, rolesResponse, applicationsResponse, usersWithRoles, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            setDataLoading(true);
                            setRolesLoading(true);
                            setError(null);
                            _context.p = 1;
                            _context.n = 2;
                            return Promise.all([UserAPI.getUsersWithRoles(), UserAPI.getRoles(), UserAPI.getApplications()]);
                        case 2:
                            _yield$Promise$all = _context.v;
                            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                            usersWithRolesResponse = _yield$Promise$all2[0];
                            rolesResponse = _yield$Promise$all2[1];
                            applicationsResponse = _yield$Promise$all2[2];
                            setRoles(rolesResponse.resource);
                            setApplications(applicationsResponse.resource);
                            setRolesLoading(false);
                            // Transform the aggregated user data to match the existing format
                            usersWithRoles = usersWithRolesResponse.resource.map(function (user) {
                                var _user$roles, _user$userAttributes, _user$userAttributes2, _user$metadata;
                                var userRoles = ((_user$roles = user.roles) === null || _user$roles === void 0 ? void 0 : _user$roles.map(function (roleObj) {
                                    return roleObj.role_name;
                                })) || [];
                                return {
                                    id: user.id,
                                    avatarUrl: '',
                                    name: ((_user$userAttributes = user.userAttributes) === null || _user$userAttributes === void 0 ? void 0 : _user$userAttributes.name) || user.username,
                                    email: ((_user$userAttributes2 = user.userAttributes) === null || _user$userAttributes2 === void 0 ? void 0 : _user$userAttributes2.email) || user.username,
                                    role: userRoles,
                                    // Support multiple roles
                                    dateAdded: (_user$metadata = user.metadata) !== null && _user$metadata !== void 0 && _user$metadata.createdDate ? new Date(user.metadata.createdDate).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    }) : 'Unknown'
                                };
                            });
                            setUsers(usersWithRoles);
                            // Set default access filter to first application if available
                            if (applicationsResponse.resource.length > 0) {
                                setAccessFilter(applicationsResponse.resource[0].name);
                            }
                            _context.n = 4;
                            break;
                        case 3:
                            _context.p = 3;
                            _t = _context.v;
                            console.error('Failed to load data:', _t);
                            setError('Failed to load users, roles, and applications. Please try again.');
                        case 4:
                            _context.p = 4;
                            setDataLoading(false);
                            setRolesLoading(false);
                            return _context.f(4);
                        case 5:
                            return _context.a(2);
                    }
            }, _callee, null, [[1, 3, 4, 5]]);
        }));
        return function loadInitialData() {
            return _ref.apply(this, arguments);
        };
    }();
    // Effect to correct user roles when roles are loaded
    useEffect(function () {
        if (roles.length > 0 && users.length > 0) {
            var correctedUsers = users.map(function (user) {
                // Ensure user role is always an array
                var userRoles = Array.isArray(user.role) ? user.role : [user.role];
                // Check if user's roles exist in available roles
                var validRoles = userRoles.filter(function (role) {
                    return roles.some(function (availableRole) {
                        return availableRole.role_name === role;
                    });
                });
                if (validRoles.length === 0) {
                    // If no valid roles exist, assign the first available role
                    console.warn("User ".concat(user.email, " has invalid roles \"").concat(userRoles.join(', '), "\", correcting to \"").concat(roles[0].role_name, "\""));
                    return _objectSpread(_objectSpread({}, user), {}, {
                        role: [roles[0].role_name]
                    });
                }
                else if (validRoles.length !== userRoles.length) {
                    // If some roles are invalid, keep only valid ones
                    console.warn("User ".concat(user.email, " has some invalid roles, keeping only valid ones: \"").concat(validRoles.join(', '), "\""));
                    return _objectSpread(_objectSpread({}, user), {}, {
                        role: validRoles
                    });
                }
                return _objectSpread(_objectSpread({}, user), {}, {
                    role: userRoles
                });
            });
            // Only update if there were changes
            var hasChanges = correctedUsers.some(function (user, index) {
                var originalRoles = Array.isArray(users[index].role) ? users[index].role : [users[index].role];
                var correctedRoles = Array.isArray(user.role) ? user.role : [user.role];
                return JSON.stringify(originalRoles.sort()) !== JSON.stringify(correctedRoles.sort());
            });
            if (hasChanges) {
                setUsers(correctedUsers);
            }
        }
    }, [roles, users.length]); // Only depend on roles and users.length to avoid infinite loops
    // Handler functions
    var handleAddUser = function handleAddUser() {
        setSelectedUser(null);
        setUserModalOpen(true);
    };
    // const handleEditUser = (user: TeamUser) => {
    // 	setSelectedUser(user)
    // 	setUserModalOpen(true)
    // }
    var handleViewUserDetails = function handleViewUserDetails(user) {
        setSelectedUserForDetails(user);
        setUserDetailsModalOpen(true);
    };
    var handleDeleteUser = function handleDeleteUser(user) {
        setUserToDelete(user);
        setConfirmDialogOpen(true);
    };
    var handleSaveUser = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(usersData) {
            var newUsers, errors, _loop, i, _t4;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.p = _context3.n) {
                        case 0:
                            setLoading(true);
                            setError(null);
                            _context3.p = 1;
                            newUsers = [];
                            errors = [];
                            _loop = /*#__PURE__*/ _regenerator().m(function _loop() {
                                var userData, userRoles, selectedRoleObjs, existingUser, updateData, createData, response, newUser, _iterator, _step, roleObj, transformedUser, errorMessage, _t2, _t3;
                                return _regenerator().w(function (_context2) {
                                    while (1)
                                        switch (_context2.p = _context2.n) {
                                            case 0:
                                                userData = usersData[i];
                                                _context2.p = 1;
                                                console.log("Processing user ".concat(i + 1, "/").concat(usersData.length, ":"), userData.email);
                                                // Handle role assignment - support both single role and multiple roles
                                                userRoles = Array.isArray(userData.role) ? userData.role : [userData.role]; // Find the role objects from the role names
                                                selectedRoleObjs = userRoles.map(function (roleName) {
                                                    var roleObj = roles.find(function (role) {
                                                        return role.role_name === roleName;
                                                    });
                                                    if (!roleObj) {
                                                        throw new Error("Role '".concat(roleName, "' not found"));
                                                    }
                                                    return roleObj;
                                                }); // Validate email format
                                                if (!(!userData.email || !userData.email.includes('@'))) {
                                                    _context2.n = 2;
                                                    break;
                                                }
                                                throw new Error('Invalid email address');
                                            case 2:
                                                // Check if user already exists in the current list to prevent duplicates
                                                existingUser = users.find(function (u) {
                                                    return u.email === userData.email;
                                                });
                                                if (!existingUser) {
                                                    _context2.n = 3;
                                                    break;
                                                }
                                                throw new Error('User already exists');
                                            case 3:
                                                if (!selectedUser) {
                                                    _context2.n = 6;
                                                    break;
                                                }
                                                // Edit existing user (only applies to single user edit)
                                                updateData = {
                                                    userAttributes: {
                                                        name: userData.name,
                                                        email: userData.email
                                                        // Remove role from userAttributes - it will be managed via principalrole
                                                    }
                                                };
                                                _context2.n = 4;
                                                return UserAPI.updateUser(selectedUser.id, updateData);
                                            case 4:
                                                _context2.n = 5;
                                                return UserAPI.updateUserRole(userData.email, {
                                                    roleId: parseInt(selectedRoleObjs[0].role_id)
                                                });
                                            case 5:
                                                // Update local state
                                                setUsers(function (prevUsers) {
                                                    return prevUsers.map(function (u) {
                                                        return u.id === selectedUser.id ? _objectSpread(_objectSpread({}, userData), {}, {
                                                            id: selectedUser.id,
                                                            dateAdded: selectedUser.dateAdded
                                                        }) : u;
                                                    });
                                                });
                                                _context2.n = 18;
                                                break;
                                            case 6:
                                                // Add new user
                                                console.log('Creating user with data:', {
                                                    resourceType: 'User',
                                                    username: userData.email,
                                                    organization_id: 1,
                                                    principal_type: 1,
                                                    userAttributes: {
                                                        name: userData.name,
                                                        email: userData.email
                                                    }
                                                });
                                                createData = {
                                                    resourceType: 'User',
                                                    username: userData.email,
                                                    organization_id: 1,
                                                    principal_type: 1,
                                                    userAttributes: {
                                                        name: userData.name,
                                                        email: userData.email
                                                    }
                                                };
                                                _context2.n = 7;
                                                return UserAPI.createUser(createData);
                                            case 7:
                                                response = _context2.v;
                                                console.log('Full API response:', response);
                                                // The response is now a single User object, not a Bundle
                                                newUser = response;
                                                console.log('User created successfully:', newUser);
                                                // Validate that newUser has required properties
                                                if (!(!newUser || !newUser.id || !newUser.username)) {
                                                    _context2.n = 8;
                                                    break;
                                                }
                                                throw new Error('User creation succeeded but returned incomplete user data');
                                            case 8:
                                                _context2.n = 9;
                                                return new Promise(function (resolve) {
                                                    return setTimeout(resolve, 100);
                                                });
                                            case 9:
                                                // Assign each role sequentially
                                                _iterator = _createForOfIteratorHelper(selectedRoleObjs);
                                                _context2.p = 10;
                                                _iterator.s();
                                            case 11:
                                                if ((_step = _iterator.n()).done) {
                                                    _context2.n = 14;
                                                    break;
                                                }
                                                roleObj = _step.value;
                                                _context2.n = 12;
                                                return UserAPI.assignRole(newUser.username, {
                                                    roleId: parseInt(roleObj.role_id)
                                                });
                                            case 12:
                                                console.log("Role ".concat(roleObj.role_name, " assigned successfully"));
                                            case 13:
                                                _context2.n = 11;
                                                break;
                                            case 14:
                                                _context2.n = 16;
                                                break;
                                            case 15:
                                                _context2.p = 15;
                                                _t2 = _context2.v;
                                                _iterator.e(_t2);
                                            case 16:
                                                _context2.p = 16;
                                                _iterator.f();
                                                return _context2.f(16);
                                            case 17:
                                                transformedUser = {
                                                    id: newUser.id,
                                                    avatarUrl: userData.avatarUrl || '',
                                                    name: userData.name,
                                                    email: userData.email,
                                                    role: userRoles,
                                                    // Store all roles
                                                    dateAdded: new Date().toLocaleDateString('en-US', {
                                                        month: 'short',
                                                        day: 'numeric',
                                                        year: 'numeric'
                                                    })
                                                };
                                                newUsers.push(transformedUser);
                                                console.log("Successfully processed user ".concat(i + 1, "/").concat(usersData.length));
                                            case 18:
                                                _context2.n = 20;
                                                break;
                                            case 19:
                                                _context2.p = 19;
                                                _t3 = _context2.v;
                                                console.error("Failed to process user ".concat(userData.email, ":"), _t3);
                                                errorMessage = _t3 instanceof Error ? _t3.message : 'Unknown error';
                                                errors.push("".concat(userData.email, ": ").concat(errorMessage));
                                            // Continue with the next user instead of stopping the entire process
                                            case 20:
                                                return _context2.a(2);
                                        }
                                }, _loop, null, [[10, 15, 16, 17], [1, 19]]);
                            });
                            i = 0;
                        case 2:
                            if (!(i < usersData.length)) {
                                _context3.n = 4;
                                break;
                            }
                            return _context3.d(_regeneratorValues(_loop()), 3);
                        case 3:
                            i++;
                            _context3.n = 2;
                            break;
                        case 4:
                            // Add all successfully created users to the state
                            if (newUsers.length > 0) {
                                setUsers(function (prevUsers) {
                                    return [].concat(_toConsumableArray(prevUsers), newUsers);
                                });
                            }
                            // Show appropriate message based on results
                            if (errors.length > 0 && newUsers.length > 0) {
                                setError("Some users could not be added: ".concat(errors.join(', ')));
                            }
                            else if (errors.length > 0 && newUsers.length === 0) {
                                setError("Failed to add users: ".concat(errors.join(', ')));
                            }
                            else if (newUsers.length > 0) {
                                console.log("Successfully added ".concat(newUsers.length, " user(s)"));
                            }
                            // Close modal only if at least one user was successfully added
                            if (newUsers.length > 0) {
                                setUserModalOpen(false);
                            }
                            _context3.n = 6;
                            break;
                        case 5:
                            _context3.p = 5;
                            _t4 = _context3.v;
                            console.error('Unexpected error in handleSaveUser:', _t4);
                            setError('An unexpected error occurred. Please try again.');
                        case 6:
                            _context3.p = 6;
                            setLoading(false);
                            return _context3.f(6);
                        case 7:
                            return _context3.a(2);
                    }
            }, _callee2, null, [[1, 5, 6, 7]]);
        }));
        return function handleSaveUser(_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    var handleConfirmDelete = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var _t5;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.p = _context4.n) {
                        case 0:
                            if (!userToDelete) {
                                _context4.n = 5;
                                break;
                            }
                            setLoading(true);
                            setError(null);
                            _context4.p = 1;
                            _context4.n = 2;
                            return UserAPI.deleteUser(userToDelete.id);
                        case 2:
                            setUsers(function (prevUsers) {
                                return prevUsers.filter(function (u) {
                                    return u.id !== userToDelete.id;
                                });
                            });
                            setConfirmDialogOpen(false);
                            setUserToDelete(null);
                            _context4.n = 4;
                            break;
                        case 3:
                            _context4.p = 3;
                            _t5 = _context4.v;
                            console.error('Failed to delete user:', _t5);
                            setError('Failed to delete user. Please try again.');
                        case 4:
                            _context4.p = 4;
                            setLoading(false);
                            return _context4.f(4);
                        case 5:
                            return _context4.a(2);
                    }
            }, _callee3, null, [[1, 3, 4, 5]]);
        }));
        return function handleConfirmDelete() {
            return _ref3.apply(this, arguments);
        };
    }();
    var handleSelectAll = function handleSelectAll(checked) {
        setSelectedUsers(checked ? users.map(function (u) {
            return u.id;
        }) : []);
    };
    var handleSelectUser = function handleSelectUser(userId, checked) {
        setSelectedUsers(function (prev) {
            return checked ? [].concat(_toConsumableArray(prev), [userId]) : prev.filter(function (id) {
                return id !== userId;
            });
        });
    };
    // Helper function to get available roles for dropdown
    var getAvailableRoles = function getAvailableRoles(user) {
        // Filter roles based on selected application
        var filteredRoles = function () {
            if (!accessFilter)
                return roles;
            var selectedApp = applications.find(function (app) {
                return app.name === accessFilter;
            });
            if (!selectedApp)
                return roles;
            return roles.filter(function (role) {
                return String(role.application_id) === String(selectedApp.id);
            });
        }();
        // Add user's current roles to available options (even from other applications)
        var currentUserRoles = Array.isArray(user.role) ? user.role : [user.role];
        var userRoleObjects = currentUserRoles.filter(function (roleName) {
            return roleName && roleName.trim() !== '';
        }).map(function (roleName) {
            return roles.find(function (role) {
                return role.role_name === roleName;
            });
        }).filter(function (role) {
            return role !== undefined;
        });
        // Combine filtered roles with user's current roles (remove duplicates)
        var allAvailableRoles = _toConsumableArray(filteredRoles);
        userRoleObjects.forEach(function (userRole) {
            if (!allAvailableRoles.find(function (role) {
                return role.role_id === userRole.role_id;
            })) {
                allAvailableRoles.push(userRole);
            }
        });
        return allAvailableRoles;
    };
    // Helper function to get dropdown value for user
    var getDropdownValue = function getDropdownValue(user) {
        var currentRoles = Array.isArray(user.role) ? user.role : [user.role];
        // Return ALL user roles (don't filter by application)
        // This ensures users can see all their assigned roles regardless of current filter
        var validRoles = currentRoles.filter(function (role) {
            return role && role.trim() !== '';
        });
        console.log("=== DROPDOWN DEBUG for ".concat(user.email, " ==="));
        console.log("User roles:", currentRoles);
        console.log("Dropdown value (all roles):", validRoles);
        return validRoles;
    };
    var handleRoleChange = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4(userId, newRoles) {
            var user, rolesArray, currentRoles, rolesToAdd, rolesToRemove, _iterator2, _step2, _loop2, _iterator3, _step3, _loop3, _t6, _t7, _t8;
            return _regenerator().w(function (_context7) {
                while (1)
                    switch (_context7.p = _context7.n) {
                        case 0:
                            _context7.p = 0;
                            // Find the user to get their username
                            user = users.find(function (u) {
                                return u.id === userId;
                            });
                            if (user) {
                                _context7.n = 1;
                                break;
                            }
                            return _context7.a(2);
                        case 1:
                            // Ensure newRoles is always an array
                            rolesArray = Array.isArray(newRoles) ? newRoles : [newRoles]; // Get current user roles
                            currentRoles = Array.isArray(user.role) ? user.role : [user.role]; // Find roles to add and remove
                            rolesToAdd = rolesArray.filter(function (role) {
                                return !currentRoles.includes(role);
                            });
                            rolesToRemove = currentRoles.filter(function (role) {
                                return !rolesArray.includes(role);
                            }); // Process role additions
                            _iterator2 = _createForOfIteratorHelper(rolesToAdd);
                            _context7.p = 2;
                            _loop2 = /*#__PURE__*/ _regenerator().m(function _loop2() {
                                var roleName, roleObj;
                                return _regenerator().w(function (_context5) {
                                    while (1)
                                        switch (_context5.n) {
                                            case 0:
                                                roleName = _step2.value;
                                                roleObj = roles.find(function (r) {
                                                    return r.role_name === roleName;
                                                });
                                                if (!roleObj) {
                                                    _context5.n = 1;
                                                    break;
                                                }
                                                _context5.n = 1;
                                                return UserAPI.assignRole(user.email, {
                                                    roleId: parseInt(roleObj.role_id)
                                                });
                                            case 1:
                                                return _context5.a(2);
                                        }
                                }, _loop2);
                            });
                            _iterator2.s();
                        case 3:
                            if ((_step2 = _iterator2.n()).done) {
                                _context7.n = 5;
                                break;
                            }
                            return _context7.d(_regeneratorValues(_loop2()), 4);
                        case 4:
                            _context7.n = 3;
                            break;
                        case 5:
                            _context7.n = 7;
                            break;
                        case 6:
                            _context7.p = 6;
                            _t6 = _context7.v;
                            _iterator2.e(_t6);
                        case 7:
                            _context7.p = 7;
                            _iterator2.f();
                            return _context7.f(7);
                        case 8:
                            // Process role removals
                            _iterator3 = _createForOfIteratorHelper(rolesToRemove);
                            _context7.p = 9;
                            _loop3 = /*#__PURE__*/ _regenerator().m(function _loop3() {
                                var roleName, roleObj;
                                return _regenerator().w(function (_context6) {
                                    while (1)
                                        switch (_context6.n) {
                                            case 0:
                                                roleName = _step3.value;
                                                roleObj = roles.find(function (r) {
                                                    return r.role_name === roleName;
                                                });
                                                if (!roleObj) {
                                                    _context6.n = 2;
                                                    break;
                                                }
                                                _context6.n = 1;
                                                return UserAPI.removeRole(user.id, parseInt(roleObj.role_id));
                                            case 1:
                                                console.log("Successfully removed role ".concat(roleName, " from user ").concat(user.email));
                                            case 2:
                                                return _context6.a(2);
                                        }
                                }, _loop3);
                            });
                            _iterator3.s();
                        case 10:
                            if ((_step3 = _iterator3.n()).done) {
                                _context7.n = 12;
                                break;
                            }
                            return _context7.d(_regeneratorValues(_loop3()), 11);
                        case 11:
                            _context7.n = 10;
                            break;
                        case 12:
                            _context7.n = 14;
                            break;
                        case 13:
                            _context7.p = 13;
                            _t7 = _context7.v;
                            _iterator3.e(_t7);
                        case 14:
                            _context7.p = 14;
                            _iterator3.f();
                            return _context7.f(14);
                        case 15:
                            // Update local state
                            setUsers(function (prevUsers) {
                                return prevUsers.map(function (u) {
                                    return u.id === userId ? _objectSpread(_objectSpread({}, u), {}, {
                                        role: rolesArray
                                    }) : u;
                                });
                            });
                            _context7.n = 17;
                            break;
                        case 16:
                            _context7.p = 16;
                            _t8 = _context7.v;
                            console.error('Failed to update roles:', _t8);
                            setError('Failed to update user roles. Please try again.');
                        case 17:
                            return _context7.a(2);
                    }
            }, _callee4, null, [[9, 13, 14, 15], [2, 6, 7, 8], [0, 16]]);
        }));
        return function handleRoleChange(_x2, _x3) {
            return _ref4.apply(this, arguments);
        };
    }();
    var handleUserDetailsDelete = function handleUserDetailsDelete(user) {
        setUserToDelete(user);
        setConfirmDialogOpen(true);
        setUserDetailsModalOpen(false);
    };
    var handleWorkspaceRoleChange = /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5(userId, newRole) {
            return _regenerator().w(function (_context8) {
                while (1)
                    switch (_context8.n) {
                        case 0:
                            _context8.n = 1;
                            return handleRoleChange(userId, [newRole]);
                        case 1:
                            return _context8.a(2);
                    }
            }, _callee5);
        }));
        return function handleWorkspaceRoleChange(_x4, _x5) {
            return _ref5.apply(this, arguments);
        };
    }();
    var handleApplicationRoleChange = /*#__PURE__*/ function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6(userId, updatedRoles) {
            return _regenerator().w(function (_context9) {
                while (1)
                    switch (_context9.n) {
                        case 0:
                            _context9.n = 1;
                            return handleRoleChange(userId, updatedRoles);
                        case 1:
                            return _context9.a(2);
                    }
            }, _callee6);
        }));
        return function handleApplicationRoleChange(_x6, _x7) {
            return _ref6.apply(this, arguments);
        };
    }();
    // Check view permission
    if (!isAuthorized('RBAC:ViewUser')) {
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                p: 3,
                bgcolor: '#f8f8f8'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                textAlign: 'center',
                py: 8
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "#666",
            gutterBottom: true
        }, "Access Denied"), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#888"
        }, "You don't have permission to view team access settings.")));
    }
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3,
            bgcolor: '#f8f8f8'
        }
    }, error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mb: 2
        },
        onClose: function onClose() {
            return setError(null);
        }
    }, error), dataLoading ? /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            p: 4
        }
    }, /*#__PURE__*/ React.createElement(CircularProgress, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Paper, {
        sx: {
            p: 3,
            borderRadius: 2,
            boxShadow: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 3
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            minWidth: 343
        }
    }, /*#__PURE__*/ React.createElement(FormControl, {
        fullWidth: true
    }, /*#__PURE__*/ React.createElement(InputLabel, null, "Access"), /*#__PURE__*/ React.createElement(Select, {
        value: accessFilter,
        onChange: function onChange(e) {
            return setAccessFilter(e.target.value);
        },
        label: "Access",
        disabled: applications.length === 0
    }, applications.length === 0 ? /*#__PURE__*/ React.createElement(MenuItem, {
        value: "",
        disabled: true
    }, "Loading applications...") : applications.map(function (app) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: app.id,
            value: app.name
        }, app.name);
    })))), /*#__PURE__*/ React.createElement(Box, null, selectedUsers.length > 0 && isAuthorized('RBAC:DeleteUser') && /*#__PURE__*/ React.createElement(Button, {
        variant: "outlined",
        sx: {
            color: '#DA291C',
            border: '1px solid #DA291C',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            mr: 1
        }
    }, /*#__PURE__*/ React.createElement(DeleteIcon, null)), isAuthorized('RBAC:CreateUser') && /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        startIcon: /*#__PURE__*/ React.createElement(AddIcon, null),
        onClick: handleAddUser,
        sx: {
            textTransform: 'none',
            boxShadow: 'none'
        }
    }, "Member"))), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 3
        }
    }, "View member details and manage their default workspace permission. Click into them to customize their access on an application level."), /*#__PURE__*/ React.createElement(TableContainer, {
        component: Paper,
        sx: {
            borderRadius: 2,
            boxShadow: 'none',
            border: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Table, {
        sx: {
            minWidth: 650
        }
    }, /*#__PURE__*/ React.createElement(TableHead, null, /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 2
        }
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        checked: selectedUsers.length === users.length,
        indeterminate: selectedUsers.length > 0 && selectedUsers.length < users.length,
        onChange: function onChange(e) {
            return handleSelectAll(e.target.checked);
        },
        sx: {
            color: '#d9d9d9',
            '&.Mui-checked': {
                color: '#26890d'
            }
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121'
        }
    }, "Name"), /*#__PURE__*/ React.createElement(FilterIcon, {
        sx: {
            fontSize: 18,
            color: '#26890d'
        }
    }))), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121'
        }
    }, "Email")), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121'
        }
    }, "Role"), /*#__PURE__*/ React.createElement(Tooltip, {
        title: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("strong", null, "Admin"), /*#__PURE__*/ React.createElement("br", null), "Can add or remove users and apps, assign roles, and update apps.", /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("strong", null, "Editor"), /*#__PURE__*/ React.createElement("br", null), "-", /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("strong", null, "Viewer"), /*#__PURE__*/ React.createElement("br", null), "View-only access to assigned workspaces or apps.", /*#__PURE__*/ React.createElement("br", null), "Cannot make changes or see anything unassigned."),
        placement: "top",
        slotProps: {
            popper: {
                sx: {
                    '& .MuiTooltip-tooltip': {
                        bgcolor: '#26890D',
                        color: '#ffffff'
                    }
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(InfoIcon, {
        sx: {
            fontSize: 20,
            color: '#26890D',
            '&:hover': {
                cursor: 'pointer'
            }
        }
    })))), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121'
        }
    }, "Date added")), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 2,
            px: 4,
            width: 200
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            color: '#212121'
        }
    }, "Action")))), /*#__PURE__*/ React.createElement(TableBody, null, users.map(function (user, index) {
        return /*#__PURE__*/ React.createElement(TableRow, {
            key: user.id,
            sx: {
                borderTop: index > 0 ? '1px solid #ebebeb' : 'none'
            }
        }, /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                alignItems: 'center',
                gap: 2
            }
        }, /*#__PURE__*/ React.createElement(Checkbox, {
            checked: selectedUsers.includes(user.id),
            onChange: function onChange(e) {
                return handleSelectUser(user.id, e.target.checked);
            },
            sx: {
                color: '#d9d9d9',
                '&.Mui-checked': {
                    color: '#26890d'
                }
            }
        }), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            sx: {
                fontWeight: 600,
                color: '#26890d',
                textDecoration: 'underline',
                cursor: 'pointer'
            },
            onClick: function onClick() {
                return handleViewUserDetails(user);
            }
        }, user.name))), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#212121"
        }, user.email)), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55
            }
        }, /*#__PURE__*/ React.createElement(FormControl, {
            sx: {
                minWidth: 120,
                maxWidth: 300
            }
        }, /*#__PURE__*/ React.createElement(Select, {
            multiple: true,
            value: getDropdownValue(user),
            onChange: function onChange(e) {
                var value = e.target.value;
                var selectedRoles = typeof value === 'string' ? [value] : value;
                handleRoleChange(user.id, selectedRoles);
            },
            size: "small",
            disabled: rolesLoading || !isAuthorized('RBAC:AssignRole'),
            renderValue: function renderValue(selected) {
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 0.5
                    }
                }, selected.map(function (value) {
                    return /*#__PURE__*/ React.createElement(Chip, {
                        key: value,
                        label: value,
                        size: "small",
                        sx: {
                            backgroundColor: '#f3f8eb',
                            color: '#1a5d09',
                            fontFamily: 'Open Sans',
                            fontSize: 12,
                            fontWeight: 600,
                            height: 20
                        }
                    });
                }));
            },
            sx: {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#d9d9d9'
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#26890D'
                },
                width: 300
            }
        }, rolesLoading ? /*#__PURE__*/ React.createElement(MenuItem, {
            value: "",
            disabled: true
        }, "Loading roles...") : function () {
            var availableRoles = getAvailableRoles(user);
            if (availableRoles.length === 0) {
                return /*#__PURE__*/ React.createElement(MenuItem, {
                    value: "",
                    disabled: true
                }, "No roles available");
            }
            var currentRoles = Array.isArray(user.role) ? user.role : [user.role];
            return availableRoles.map(function (role) {
                var isChecked = currentRoles.includes(role.role_name);
                return /*#__PURE__*/ React.createElement(MenuItem, {
                    key: role.role_id,
                    value: role.role_name
                }, /*#__PURE__*/ React.createElement(Checkbox, {
                    checked: isChecked
                }), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "body1"
                }, role.role_name));
            });
        }()))), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#212121"
        }, user.dateAdded)), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                py: 2,
                px: 4,
                height: 55
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                gap: 2
            }
        }, isAuthorized('RBAC:DeleteUser') && /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function onClick() {
                return handleDeleteUser(user);
            },
            sx: {
                color: '#da291c',
                '&:hover': {
                    bgcolor: 'rgba(218, 41, 28, 0.04)'
                }
            }
        }, /*#__PURE__*/ React.createElement(DeleteIcon, {
            fontSize: "small"
        })))));
    }))))), /*#__PURE__*/ React.createElement(AddUserModal, {
        open: userModalOpen,
        onClose: function onClose() {
            return setUserModalOpen(false);
        },
        onSave: handleSaveUser,
        user: selectedUser,
        loading: loading,
        accessFilter: accessFilter,
        accessOptions: applications.map(function (app) {
            return app.name;
        }),
        roles: function () {
            // Filter roles based on selected application
            if (!accessFilter)
                return roles.map(function (role) {
                    return role.role_name;
                });
            // Find the selected application
            var selectedApp = applications.find(function (app) {
                return app.name === accessFilter;
            });
            if (!selectedApp)
                return roles.map(function (role) {
                    return role.role_name;
                });
            // Filter roles that belong to the selected application
            var filteredRoles = roles.filter(function (role) {
                return String(role.application_id) === String(selectedApp.id);
            });
            return filteredRoles.map(function (role) {
                return role.role_name;
            });
        }()
    }), /*#__PURE__*/ React.createElement(UserDetailsModal, {
        open: userDetailsModalOpen,
        onClose: function onClose() {
            return setUserDetailsModalOpen(false);
        },
        user: selectedUserForDetails,
        onDelete: handleUserDetailsDelete,
        onWorkspaceRoleChange: handleWorkspaceRoleChange,
        onApplicationRoleChange: handleApplicationRoleChange
    }), /*#__PURE__*/ React.createElement(ConfirmationDialog, {
        isOpen: confirmDialogOpen,
        setIsOpen: setConfirmDialogOpen,
        title: "Delete User",
        bodyText: "Are you sure you want to delete ".concat(userToDelete === null || userToDelete === void 0 ? void 0 : userToDelete.name, "? This action cannot be undone."),
        submitFunction: handleConfirmDelete,
        submitButtonText: "Delete",
        loading: loading
    })));
};
export default TeamAccess;
